import axios from "axios";
import config from "../config";
import { getDoctorToken } from "../utils"

const saveAppointmentCompleteStatusApi = async (params) => {
  const response = await axios({
    url: `${config.api.base_url}book-appointment/appointment-completed`,
    method: "put",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getDoctorToken()}`
    },
  });

  return response;
};

export default saveAppointmentCompleteStatusApi;
